export const AUTH_CONSTANTS = {
    USER_CACHE_KEY: 'cachedUser',
};
